import i18n from 'i18next';

export const getsortOptions = () => [
  { value: 'priceIncrease', label: i18n.t('sort.price_increase') },
  { value: 'priceDecrease', label: i18n.t('sort.price_decrease') },
  { value: 'starIncrease', label: i18n.t('sort.star_increase') },
  { value: 'starDecrease', label: i18n.t('sort.star_decrease') },
  { value: 'nameIncrease', label: i18n.t('sort.hotel_increase') },
  { value: 'nameDecrease', label: i18n.t('sort.hotel_decrease') },
];

export const flightSourcesDef = [
  { value: 'ALP', label: 'ALP' },
  { value: 'SAB_LDS', label: 'LDS' },
  { value: 'ABOX', label: 'ABOX' },
];

export enum PassengerType {
  Adult = 'ADT',
  Senior = 'SRC',
  Child = 'CNN',
  Infant = 'INF',
  Youth = 'YTH',
}

export const getGender = (type: PassengerType) => {
  if (type === PassengerType.Adult) {
    return [
      { value: 'M', label: 'male' },
      { value: 'F', label: 'female' },
    ];
  } else if (type === PassengerType.Infant) {
    return [{ value: 'C', label: 'search.infant' }];
  } else {
    return [{ value: 'C', label: 'child' }];
  }
};

export const getGenderString = (input: string) => {
  if (input === 'M') {
    return i18n.t('passenger.male');
  } else if (input === 'F') {
    return i18n.t('passenger.female');
  }
};

export const getPackagePassengerValidation = (index: number) => {
  const baseValidation = {
    firstName: { required: true, minLength: 2, maxLength: 20, english: true },
    lastName: { required: true, minLength: 2, maxLength: 20, english: true },
    phone: {},
    email: {},
  };
  if (index === 0) {
    return {
      ...baseValidation,
      email: { required: true, email: true },
      phone: { required: true },
    };
  } else {
    return baseValidation;
  }
};

